import { IKitDropdownRef } from '@models/IKitDropdownRef';
import { IProductListingStatusLabels } from '@models/IProductListingStatusLabels';
import { IProductVariant } from '@models/IProductVariant';
import KitCard from '@molecules/KitCard/KitCard';
import classNames from 'classnames';
import { forwardRef, useImperativeHandle, useRef } from 'react';

interface Props {
  readonly kitTitleLabel: string;
  readonly kitsTitleLabel: string;
  readonly productListingName?: string;
  readonly statusLabels: IProductListingStatusLabels;
  readonly variations: IProductVariant[];
  readonly isLightMode?: boolean;
}

const KitDropdown = forwardRef<IKitDropdownRef, Props>(
  (
    {
      kitTitleLabel,
      kitsTitleLabel,
      productListingName,
      statusLabels,
      variations = [],
      isLightMode,
    }: Props,
    ref
  ) => {
    const sectionRef = useRef<HTMLDivElement | null>(null);
    const kits =
      variations?.filter((variation) => variation.type === 'kit') ?? [];

    useImperativeHandle(ref, () => ({
      scrollIntoView: () => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
      },
    }));

    return (
      <section
        ref={sectionRef}
        className={classNames(
          'mt-4 py-15 md:pb-36 md:pt-24',
          isLightMode ? 'bg-grey-100 text-black-100' : 'bg-grey-600 text-white'
        )}
      >
        <div>
          {kitsTitleLabel && kitTitleLabel && (
            <h4 className="container mb-5 md:mb-6">
              {`${kits.length} ${
                kits.length > 1 ? kitsTitleLabel : kitTitleLabel
              }`}
            </h4>
          )}
          <div className="flex w-full snap-x flex-row gap-x-4 overflow-x-auto px-5 scrollbar-hide md:container md:grid md:grid-cols-2 md:gap-y-22 xl:grid-cols-3">
            {!!kits.length &&
              kits.map((kit) => (
                <div
                  key={`${kit.skuCode}-${kit.title}-kit-card`}
                  className={classNames(
                    'shrink-0 snap-center md:w-full',
                    kits.length === 1 ? 'w-full' : 'w-[80vw]'
                  )}
                >
                  <KitCard
                    productListingName={productListingName}
                    statusLabels={statusLabels}
                    {...kit}
                    isLightMode={isLightMode}
                  />
                </div>
              ))}
          </div>
        </div>
      </section>
    );
  }
);

export default KitDropdown;
